import React from 'react';

import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import style from '../manage-add-ons.module.css';
import { messages } from '../messages';
import { ReturnRabbit } from '../../../../../../../constants/upsell-modal-content-codes';

const AddOnStatusColumnId = 'addOnStatus';

const AddOnStatusCell = ({ cell }) => {
  const { lineItem, onAddAddOn, onRemoveAddOn, isMarkedForPurchase, isMarkedForRemoval } = cell.value;

  const isAddOn = !!lineItem.addOnCode;

  if (lineItem.addOnCode === ReturnRabbit) {
    return null;
  }

  if (!isAddOn) {
    return <Text className={style['add-on-price']} textType={TextType.Paragraph} value={messages.includedWithYourCurrentPlan} />;
  }

  if (isMarkedForPurchase) {
    return (
      <Button ariaLabel={`${messages.deactivate.defaultMessage}-${lineItem.addOnCode}`} onClick={onRemoveAddOn} theme='danger-link'>
        <Text textType={TextType.Paragraph} value={messages.deactivate} />
      </Button>
    );
  }

  if (lineItem.deactivationDateTimeUtc || isMarkedForRemoval) {
    return (
      <Button ariaLabel={`${messages.reactivate.defaultMessage}-${lineItem.addOnCode}`} onClick={onAddAddOn} theme='link'>
        <Text textType={TextType.Paragraph} value={messages.reactivate} />
      </Button>
    );
  }

  return (
    <Button ariaLabel={`${messages.deactivate.defaultMessage}-${lineItem.addOnCode}`} onClick={onRemoveAddOn} theme='danger-link'>
      <Text textType={TextType.Paragraph} value={messages.deactivate} />
    </Button>
  );
};

AddOnStatusCell.propTypes = {
  cell: PropTypes.object.isRequired,
};

const createAddOnStatusColumnDefinition = createColumnDefinitionBuilder({
  Header: '',
  accessor: AddOnStatusColumnId,
  Cell: AddOnStatusCell,
  width: 1,
  className: style['justify-end'],
});

export { AddOnStatusColumnId, createAddOnStatusColumnDefinition };
